import React from 'react';

import type { UserData } from '@vlabs/api/luna-api/model';

import { createFastFilterDateLabel } from '@vlabs/monokit/shared/lib/fast-filter-date-label';
import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';

import st from './CardPageFastFilters.module.sass';
// eslint-disable-next-line import-x/no-namespace
import * as fastFilters from './fast-filters';
import type { TGetCardFacesParams } from './types';
import { useCardPageFilters } from './useCardPageFilters';

function CardPageFastFilters(): React.JSX.Element | null {
  const { filters, updateFilters } = useCardPageFilters();

  const hasFilters = Object
    .entries(filters)
    .filter(([name]) => !(['page', 'page_size'] as (keyof TGetCardFacesParams)[]).includes(name as keyof TGetCardFacesParams))
    .filter(([_, value]) => !!value)
    .length > 0;

  if (!hasFilters) return null;

  return (
    <div className={st.Filters}>
      <FastFilterGroup>
        {Object.entries(filters).map(([name, value]) => {
          if (value === undefined) return undefined;
          switch (name) {
            case 'face_ids': return (
              <fastFilters.FaceIdsFilterWithBottomPopover
                data-testid={name}
                key={name}
                onClear={() => updateFilters({ face_ids: undefined })}
                value={filters.face_ids ?? ''}
              />
            );
            case 'user_data': return (
              <fastFilters.UserDataFilterWithBottomPopover
                data-testid={name}
                key={name}
                onClear={() => updateFilters({ user_data: undefined })}
                value={value as UserData}
              />
            );
            default: return undefined;
          }
        })}
        {!!(filters.create_time__gte ?? filters.create_time__lt) && (
          <fastFilters.DateFilterWithBottomPopover
            data-testid="created_at"
            key="created_at"
            onClear={() => updateFilters({ create_time__gte: undefined, create_time__lt: undefined })}
            value={createFastFilterDateLabel({
              createTimeGte: filters.create_time__gte,
              createTimeLt: filters.create_time__lt,
            })}
          />
        )}
      </FastFilterGroup>
    </div>
  );
}

export { CardPageFastFilters };
